import styled from 'styled-components';
import { color, space, textAlign, width } from 'styled-system';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { ThemeInterface } from '../theme/ThemeInterface';

type SpanProps = StyledSystemProps & {
  pointer?: boolean;
};

const Span = styled.span<SpanProps>`
  ${space};
  ${color};
  ${width};
  ${textAlign};
  font-weight: 200;
  font-size: ${props => props.theme.fontSize[1]};
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
  &:hover {
    cursor: ${(props: ThemeInterface) => (props.pointer ? 'pointer' : 'default')};
  }
`;

export default Span;
